// `id` and `chipVariant` are API/UI data and stay untranslated; the labels are
// resolved from the caller's `t` so they follow the active language. Callers
// build the list inside a `useMemo(() => getChargebackStatuses(t), [t])`.
export const CHARGEBACK_STATUSES = [
    { id: 'requested',          key: 'requested',         chipVariant: 'alert' },
    { id: 'under_review',       key: 'underReview',       chipVariant: 'info' },
    { id: 'waiting_documents',  key: 'waitingDocuments',  chipVariant: 'alert' },
    { id: 'won',                key: 'won',               chipVariant: 'success' },
    { id: 'lost',               key: 'lost',              chipVariant: 'error' },
    { id: 'reversed',           key: 'reversed',          chipVariant: 'default' },
];

export const getChargebackStatuses = (t) =>
    CHARGEBACK_STATUSES.map((status) => ({
        ...status,
        label: t(`chargebacks.statuses.${status.key}`),
    }));

export const getChargebackStatusMap = (t) =>
    Object.fromEntries(getChargebackStatuses(t).map((s) => [s.id, s]));
